<template>
  <div v-if="node">
    <el-tabs  v-model="currentTab">

      <el-tab-pane label="Общие">
        <el-form
          size="mini"
          label-position="right"
          label-width="100px"
        >
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="Название">
                <div style="display: flex">
                  <click-to-edit
                    placeholder=""
                    style="width: 100%"
                    v-model="node.model.name"
                    @input="updateNode"
                  ></click-to-edit>
                  <div style="margin-left:30px;width: 50px;text-align: right">ID: {{ node.model.id }}</div>
                </div>
              </el-form-item>
              <el-form-item label="Описание">
                <click-to-edit
                  placeholder=""
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 6}"
                  v-model="node.model.desc"
                  @input="updateNode"
                ></click-to-edit>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Шкала">
                <click-to-edit
                  v-model="node.model.scale_type"
                  type="select"
                  select-filterable
                  :select-options="$cascadingConstants.scales.typesSelectOptions"
                  placeholder=""
                  @input="updateNode"
                ></click-to-edit>
              </el-form-item>
              <el-form-item
                :label="node.model.scale_type === $cascadingConstants.scales.types.TYPE_QUALITY ? 'Тип шкалы' :  'Ед.измерения'"
              >
                <cascading-scale-unit-select
                  v-model="node.model"
                  @change="updateNode"
                ></cascading-scale-unit-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Данные">
        <el-alert
          v-if="valuesDisabled"
          :closable="false"
          style="margin-bottom: 10px"
          type="warning"
          title="У цели есть дочерние цели"
          description="Текущие значения цели не участвуют в расчете производительности. Для игнорирования выберите ручной режим на вкладке производительность"
          show-icon
        ></el-alert>

        <el-form
          size="mini"
          label-position="right"
          label-width="180px"
        >
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label="Значение">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  style="width: 100%"
                  performance-value-name="value"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
              </el-form-item>
              <el-form-item label="Расширенный режим">
                <el-switch
                  v-model="node.model.extended_performance_scale"
                  :inactive-value="false"
                  :active-value="true"
                  @change="updateNode"
                ></el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="Начальное">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  style="width: 100%"
                  performance-value-name="baseline"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
              </el-form-item>
              <el-form-item label="Минимальное" v-if="node.model.extended_performance_scale">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  performance-value-name="min"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Цель">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  style="width: 100%"
                  performance-value-name="target"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
              </el-form-item>
              <el-form-item label="Максимальное" v-if="node.model.extended_performance_scale">
                <CascadingScalePerformanceValuesInput
                  v-model="node.model"
                  performance-value-name="max"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Производительность">
        <el-alert
          v-if="performanceDisabled"
          :closable="false"
          style="margin-bottom: 10px"
          type="warning"
          title="У цели есть дочерние цели"
          description="Текущее значение производительности берется из дочерних элементов. Для игнорирования выберите ручной режим"
          show-icon
        ></el-alert>


        <el-form
          size="mini"
          label-position="right"
          label-width="280px"
        >
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="Функция расчета">
                <PerformanceFormulaSelect
                  v-model="node.model"
                  @change="updateNode"
                ></PerformanceFormulaSelect>
              </el-form-item>
              <el-form-item label="Вес">
                <click-to-edit
                  v-if="node.thisParentLink"
                  placeholder=""
                  digits-only
                  v-model="node.thisParentLink.weight"
                  @input="updateNodeParentLink(node.thisParentLink)"
                ></click-to-edit>
                <div v-else>Элемент должен быть дочерним чтобы иметь вес</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Значение полей из дочерних">
                <click-to-edit
                  v-model="node.model.child_values_aggregate_type"
                  type="select"
                  select-filterable
                  :select-options="$cascadingConstants.elementChildValuesAggregate.typesSelectOptions"
                  placeholder=""
                  @input="updateNode(node)"
                ></click-to-edit>
              </el-form-item>
              <el-form-item label="Значение результата из дочерних">
                <click-to-edit
                  v-model="node.model.child_performance_aggregate_type"
                  type="select"
                  select-filterable
                  :select-options="$cascadingConstants.elementChildPerformanceAggregate.typesSelectOptions"
                  placeholder=""
                  @input="updateNode(node)"
                ></click-to-edit>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Назначение в карту">
        <el-form
          size="mini"
          label-position="right"
          label-width="210px"
        >
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="Текущая карта">
                <div v-if="node.model.card">
                  <div>
                    {{ cardAppointmentText }}
                    <router-link
                      target="_blank"
                      :to="{ name: 'Card', params: { id: node.model.card_id } }"
                    >
                      <i class="fas fa-external-link-alt"></i>
                    </router-link>
                  </div>
                  <div>
                    <el-button
                      v-if="node.model.card_assign_type !== $cascadingConstants.elementCardAssign.types.TYPE_VQB"
                      size="mini"
                      icon="far fa-trash-alt"
                      @click="clearSelectedCard"
                    >
                      Удалить назначение
                    </el-button>
                  </div>
                </div>
                <div v-else>Не назначено в карту</div>
              </el-form-item>

              <el-form-item>
                <span slot="label">
                  Назначение в карту
                  <el-popover
                    placement="top"
                    width="400"
                    trigger="click"
                  >
                    <el-button
                      slot="reference"
                      class="table-action-button open-desc-button"
                      type="text"
                      round
                      size="mini"
                      icon="fas fa-info-circle"
                    ></el-button>
                    <div style="white-space: pre-line">Конструктор отчетов позволяет запланировать назначение. Вы можете выбрать в какую карту должна будет быть назначена цель. А потом массово все такие цели назначить

                      Цель будет добавлена в первую карту, попавшую под условия.
                      Если необходимо добавить цель сразу в несколько карт - воспользуйтесь автоматическим каскадированием
                    </div>
                  </el-popover>
                </span>

                <div v-if="!node.model.auto_cascaded">
                  <el-radio-group
                    v-model="node.model.card_assign_type"
                    size="small"
                    style="margin-bottom: 10px"
                    @change="updateNode"
                  >
                    <el-radio-button :label="null">Не назначается</el-radio-button>
                    <el-radio-button :label="1">Вручную</el-radio-button>
                    <el-radio-button :label="2">КО</el-radio-button>
                  </el-radio-group>


                  <div v-if="node.model.card_assign_type === $cascadingConstants.elementCardAssign.types.TYPE_MANUAL">
                    <cards-select-modal
                      @card-selected="cardSelected"
                    >
                      <el-button
                        slot="reference"
                        size="mini"
                        icon="far fa-hand-pointer"
                      >
                        Выбрать карту
                      </el-button>
                    </cards-select-modal>

                  </div>

                  <div v-if="node.model.card_assign_type === $cascadingConstants.elementCardAssign.types.TYPE_VQB">
                    <el-button
                      size="mini"
                      icon="fas fa-sync"
                      @click="assignNodeToCard(null)"
                    >
                      Переназначить
                    </el-button>
                    <el-button
                      size="mini"
                      icon="fas fa-sync"
                      @click="assignNodeToCard(null)"
                    >
                      Переназначить все дочерние
                    </el-button>

                    <entity-saved-report-form
                      style="margin-top: -25px"
                      :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_CASCADING_ELEMENT_CARD_ASSIGNMENTS"
                      :entity-id="node.model.id"
                      entity-report-key="cards"
                      delete-on-empty-search
                    ></entity-saved-report-form>

                  </div>
                </div>
                <div v-else>Цель добавлена автоматическим каскадированием</div>
              </el-form-item>
            </el-col>


            <el-col :span="12">
              <el-form-item label="Шкала карты">
                <CascadingCardScaleSelect
                  v-model="node.model"
                  @change="updateNode"
                ></CascadingCardScaleSelect>
              </el-form-item>
              <el-form-item label="Вес в карте">
                <click-to-edit
                  placeholder=""
                  digits-only
                  v-model="node.model.card_weight"
                  @input="updateNode"
                ></click-to-edit>
              </el-form-item>
              <el-form-item label="Результат карты">
                {{ node.model.card_bonus }}%
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>


      <el-tab-pane label="Каскадирование">
        <el-form
          size="mini"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="Автоматическое каскадирование">
            <el-radio-group
              v-model="node.model.auto_cascading_type"
              size="small"
              @change="updateNode"
            >
              <el-radio-button :label="null">Не каскадируется</el-radio-button>
              <!--            <el-radio-button :label="1">Вручную</el-radio-button>-->
              <el-radio-button :label="2">КО</el-radio-button>
            </el-radio-group>

            <div v-if="node.model.auto_cascading_type">
              <div>
                Распределение базового и целевого значений
                <click-to-edit
                  v-model="node.model.auto_cascading_target_partition_type"
                  type="select"
                  select-filterable
                  :select-options="$cascadingConstants.elementAutoCascading.targetPartitionTypesSelectOptions"
                  placeholder=""
                  @input="updateNode(node)"
                ></click-to-edit>
              </div>
              <div>
                Вес в карте
                <click-to-edit
                  v-model="node.model.auto_cascading_card_weight"
                  digits-only
                  placeholder=""
                  @input="updateNode(node)"
                ></click-to-edit>
              </div>

            </div>


            <div v-if="node.model.auto_cascading_type === $cascadingConstants.elementAutoCascading.types.TYPE_VQB">
              Конструктор отчетов позволяет запланировать каскадирование. Вы можете выбрать в какие карты должна будет
              каскадироваться цель. А потом массово все такие цели назначить

              <entity-saved-report-form
                style="margin-top: -30px"
                :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_CASCADING_ELEMENT_AUTO_CASCADING"
                :entity-id="node.model.id"
                entity-report-key="cards"
                delete-on-empty-search
              ></entity-saved-report-form>

              <el-button
                size="small"
                icon="far fa-trash-alt"
                @click="runAutoCascading"
              >
                Каскадировать
              </el-button>
              <el-switch disabled style="margin-left: 30px"></el-switch>
              Автоматически создавать элементы при создании карт
            </div>

          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Полномочия">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";
import CascadingScalePerformanceValuesInput
  from "@/modules/cascading/components/scale/CascadingScalePerformanceValuesInput.vue";
import PerformanceFormulaSelect from "@/modules/cascading/components/PerformanceFormula/PerformanceFormulaSelect.vue";
import CascadingCardScaleSelect from "@/modules/cascading/components/cardScale/CascadingCardScaleSelect.vue";
import EntitySavedReportForm from "@/components/report/builder/EntitySavedReportForm.vue";
import CardsSelectModal from "@/components/cards/CardSelectModal.vue";

export default {
  name: "ElementsTreeNodeSettingsPanel",
  components: {
    CardsSelectModal,
    EntitySavedReportForm,
    CascadingCardScaleSelect,
    PerformanceFormulaSelect,
    CascadingScalePerformanceValuesInput,
    CascadingScaleUnitSelect,
    ClickToEdit
  },
  props: {
    node: { type: Object }
  },
  computed: {
    cardAppointmentText() {
      if (!this.node.model.card) {
        return "Не назначено в карту";
      }
      return this.node.model.card.user.full_name + " " + this.node.model.card.year;
    },
    valuesDisabled() {
      if (!this.node.hasChildren) {
        return false;
      }
      return this.node.model.child_values_aggregate_type !== this.$cascadingConstants.elementChildValuesAggregate.types.TYPE_MANUAL;
    },
    performanceDisabled() {
      if (!this.node.hasChildren) {
        return false;
      }
      return this.node.model.child_performance_aggregate_type !== this.$cascadingConstants.elementChildPerformanceAggregate.types.TYPE_MANUAL;
    }
  },
  data() {
    return {
      currentTab: null
    };
  },

  methods: {
    updateNode() {
      this.$emit("update-node", this.node);
    },
    updateNodeParentLink(parentLink) {
      this.$emit("update-node-parent-link", {
        node: this.node,
        parentLink: parentLink
      });
    },

    assignNodeToCard(cardId) {
      this.$emit("assign-node-to-card", {
        node: this.node,
        cardId: cardId
      });
    },
    cardSelected(card) {
      this.assignNodeToCard(card.id);
    },
    clearSelectedCard() {
      this.assignNodeToCard(null);
    },


    runAutoCascading() {
      this.$emit("run-auto-cascading", { node: this.node });
    }
  }

};
</script>

<style lang="scss">

</style>